import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {
//   produits:Array<{src:string,titre:string,url:string,description:string}>=[
//                         {src:'mattress.png',titre:'Mattress ticking',url:'mattress-ticking',description:'The core business of the group is the manufacture of mattress ticking fabrics which are used ...'},
//                         {src:'stretch.png',titre:'Stretch fabrics',url:'stretch-fabrics',description:'Fine knit fabrics for high-end mattresses offer exceptional comfort, a silky touch and functional ...'},
//                         {src:'tarp.png',titre:'Tarpaulin fabrics',url:'tarpaulin-fabrics',description:'The out door fabrics constitute an important segment for our group, we manufacture fabrics for tarpaulins ...'},
//                         {src:'tent.png',titre:'The decorative fabrics for Caidales tents',url:'the-decorative-fabrics-for-Caidales-tents',description:'The regal fabrics constitute a national imprint and tradition of national, event, family and popular celebrations ...'},
//                         {src:'folded-ribbon.png',titre:'Tapes for mattresses',url:'tapes-for-mattresses',description:'We also manufacture fabrics with technical and functional characteristics for various uses ...'},
//                         {src:'cloth.png',titre:'The different technical fabrics',url:'the-different-technical-fabrics',description:'We complete our range with tapes that allow the assembly and closing of mattresses ...'}
//                     ];
    produits:Array<{src:string,titre:string,url:string,description:string}>=[
        {
            src:'mattress.png',
            titre:'Mattress weaving ticking jacquard Fabric',
            url:'mattress-ticking',
            description:'The core business of the group is the manufacture of mattress ticking fabrics which are used ...'
        },
        {
            src:'stretch.png',
            titre:'Mattress Knitting ticking jacquard Fabric',
            url:'stretch-fabrics',
            description:'Fine knit fabrics for high-end mattresses offer exceptional comfort, a silky touch and functional ...'
        },
        {
            src:'tarp.png',
            titre:'Tarpaulin fabric',
            url:'tarpaulin-fabric',
            description:'The out door fabrics constitute an important segment for our group, we manufacture fabrics for tarpaulins ...'
        },
        {
            src:'tent.png',
            titre:'Decorative tent Fabric',
            url:'decorative-fabric-tent',
            description:'The regal fabrics constitute a national imprint and tradition of national, event, family and popular celebrations ...'
        },
        // {
        //     src:'folded-ribbon.png',
        //     titre:'Tapes for mattresses',
        //     url:'tapes-for-mattresses',
        //     description:'We also manufacture fabrics with technical and functional characteristics for various uses ...'
        // },
        {
            src:'cloth.png',
            titre:'Technical Fabric',
            url:'technical-fabric',
            description:'We complete our range with tapes that allow the assembly and closing of mattresses ...'
        }
    ];
  constructor() { }

  ngOnInit(): void {
  }

}
